module.exports = {
  css: {
    loaderOptions: {
      sass: {
        additionalData: `@import "@/assets/styles/variables.scss";@import "@/assets/styles/functions.scss";`,
        sourceMap: true
      }
    }
  },
  pluginOptions: {
    i18n: {
      locale: "en",
      fallbackLocale: "en",
      localeDir: "locales",
      enableInSFC: false
    },
    webpackBundleAnalyzer: {
      openAnalyzer: false
    }
  },
  chainWebpack: config => {
    config.plugin("html").tap(args => {
      args[0].title = "ANALYTICAL PLATFORM";
      return args;
    });
    const svgRule = config.module.rule("svg");

    svgRule.uses.clear();

    svgRule
      .use("babel-loader")
      .loader("babel-loader")
      .end()
      .use("vue-svg-loader")
      .loader("vue-svg-loader");
  },
  pwa: {
    name: "PORTFOLIO MANAGER",
    themeColor: "#344675",
    msTileColor: "#344675",
    appleMobileWebAppCapable: "yes",
    appleMobileWebAppStatusBarStyle: "#344675",
    workboxOptions: {
      skipWaiting: true
    },
    iconPaths: {
      favicon32: "favicon-32x32.png",
      favicon16: "favicon-16x16.png",
      appleTouchIcon: "apple-touch-icon.png",
      maskIcon: "favicon.ico",
      msTileImage: "mstile-150x150.png"
    }
  },

  publicPath: process.env.BASE_URL ? process.env.BASE_URL : '/'

};
